<template>
    <div class="database-view" v-if="data" v-route-title="titleField?data.source[titleField.name]:'细览页面'">
        <div class="clear"></div>
        <div class="gengduo">
            <div class="xixun_title" v-if="titleField">
                <p>{{data.source[titleField.name]}}</p>
            </div>
            <div class="xixun_mian">
                <span v-for="field in metaFields" :key="field.name">{{field.title}}：
                    <news-field :data="data" :field="field"></news-field>
                </span>
            </div>
            <div class="contentss" v-if="contentField">
                <div class="content yq-news-section-details-page-content" v-html="formattedContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import newsService from '../../service/news'
    import htmlUtils from '../../service/html-utils'
    import NewsField from '../../components/common/NewsField'

    export default {
        name: "NewsDetails",
        components: {NewsField},
        data(){
            return {
                datasource: null,
                titleField: null,
                metaFields: [],
                contentField: null,
                data: null,
            }
        },
        created(){
            this.init()
        },
        computed:{
            formattedContent(){
                if(this.data&&this.data.source[this.contentField.name]){
                    const content = this.data.source[this.contentField.name]
                    const pattern = /<[^>]+>/g
                    let arr
                    let prevEnd = 0
                    const result = []
                    while((arr = pattern.exec(content)) !== null){
                        content.substring(prevEnd, arr.index).split(/\r?\n/)
                            .forEach(p => result.push('<p>' + htmlUtils.escapeHtml(p) + '</p>' ))
                        result.push(arr[0])
                        prevEnd = pattern.lastIndex
                    }
                    if(prevEnd < content.length){
                        content.substring(prevEnd).split(/\n/)
                            .forEach(p => result.push('<p>' + htmlUtils.escapeHtml(p) + '</p>' ))
                    }
                    return result.join('')
                }else{
                    return ''
                }
            }
        },
        methods: {
            async init() {
                const response = await newsService.getDetails({id: this.$route.query.id,
                    datasourceId: this.$route.query.datasourceId})
                const datasource = response.data.datasource
                datasource.fields = JSON.parse(datasource.fields)
                this.datasource = datasource
                for(const field of this.datasource.fields){
                    if(!field.displayInDetails){
                        continue
                    }
                    if(field.displayGroup==='TITLE'){
                        this.titleField = field
                    }else if(field.displayGroup === 'CONTENT'){
                        this.contentField = field
                    }else if(field.displayGroup === 'META'){
                        this.metaFields.push(field)
                    }
                }
                this.data = response.data.data
            }
        }
    }
</script>

<style scoped>

</style>
